<span class="mpp-image-add__content">
  <ng-content></ng-content>
</span>
